import React, { useState, useEffect } from "react";
const NewsModal = ({ isOpen, onClose, newsItem, onSave }) => {
    const [message, setMessage] = useState(newsItem ? newsItem.message : "");
    const [isactive, setIsactive] = useState(
      newsItem ? newsItem.is_active === "1" : false // Convert is_active string to boolean
    );
    useEffect(() => {
      if (newsItem) {
        setMessage(newsItem.message);
        setIsactive(newsItem.is_active === "1"); // Sync isactive with the passed newsItem (convert to boolean)
      }
    }, [newsItem]);
    const handleSave = () => {
      // Save the isactive as a string "1" or "0"
      onSave({ ...newsItem, message, is_active: isactive ? "1" : "0" });
    };
    return isOpen ? (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50">
        <div className="bg-white p-6 rounded-md w-[50%] shadow-md">
          <h2 className="text-xl font-semibold mb-4">
            {newsItem ? "Edit News" : "Create News"}
          </h2>
          <textarea
            className="w-full h-24 border border-gray-300 rounded-md"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <div className="flex items-center mt-2">
            <input
              type="radio"
              id="active"
              name="isactive"
              checked={isactive}
              onChange={() => setIsactive(true)} // Set isactive to true (active)
            />
            <label htmlFor="active" className="ml-2">Active</label>
            <input
              type="radio"
              id="inactive"
              name="isactive"
              checked={!isactive}
              onChange={() => setIsactive(false)} // Set isactive to false (inactive)
              className="ml-4"
            />
            <label htmlFor="inactive" className="ml-2">Inactive</label>
          </div>
          <div className="mt-4 flex justify-end">
            <button
              onClick={handleSave}
              className="bg-green-500 text-white px-4 py-1 rounded-md hover:bg-green-600 mr-2"
            >
              Save
            </button>
            <button
              onClick={onClose}
              className="bg-red-500 text-white px-4 py-1 rounded-md hover:bg-red-600"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    ) : null;
  };
  export default NewsModal;